var _polygon, _path, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Paper_Pencil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "39.04 48.2 39.09 52.66 42.99 50.5 57.25 26.05 53.3 23.75 39.04 48.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.84,56.66H10.33V9.59H45.84v21.1l4.08-7V9.59a4.08,4.08,0,0,0-4.08-4.08H10.33A4.08,4.08,0,0,0,6.25,9.59V56.66a4.08,4.08,0,0,0,4.08,4.08H45.84a4.08,4.08,0,0,0,4.08-4.08V44.47l-4.08,7Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 15.79,
    width: 21.75,
    height: 2.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 22.26,
    width: 28.38,
    height: 2.79
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 28.73,
    width: 21.75,
    height: 2.79
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 35.19,
    width: 28.38,
    height: 2.79
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 41.66,
    width: 21.75,
    height: 2.79
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.62,
    cy: 50.74,
    r: 2.72
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.77,
    cy: 50.74,
    r: 2.72
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 19.64 54.17 22.39 58.12 24.69 59.75 21.95 55.8 19.64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBlack);
export default __webpack_public_path__ + "static/media/form-black.680c063f07968820b1ae844c482c6ee1.svg";
export { ForwardRef as ReactComponent };